export interface EmailNotification {
    notificationType: number; // 1 = solicitud de material, 2 = sugerencias
    receiverEmails: string[];
}

export interface EmailNotificationRequest {
    notificationType: number;
    receiverEmails: string[];
}

export enum NotificationType {
    MATERIAL_REQUEST = 1,
    SUGGESTIONS = 2
}
